import {Injectable} from '@angular/core';
import {LoggingService} from './LoggingService.service';
import {DataServices} from './data.services';
import {Campaign} from '../models/campaign.model';

@Injectable()
export class CampaignsService{

  campaign: Campaign = new Campaign(-1,'', '','','','', new Date(), new Date(), '', 0 );

  constructor(private dataServices: DataServices){}

  getCampaign(idCamp: string){
     return this.dataServices.getCampaign(idCamp);
  }

  setCampaign(campaign: Campaign){
    this.campaign = campaign;
  }

}
